import CheckboxV2 from "components/CheckboxV2";

import cn from "lib/cn";

import { TTabeField, TTableRecord } from "../types";

import styles from "./TableRow.module.css";

interface TableRowProps {
  keyId: string;
  record: TTableRecord;
  fields: TTabeField[];
  hasCheckbox?: boolean;
  isSelected?: boolean;
  position?: number;
  loading?: boolean;
  onSelect?: (id: string, checked: boolean) => void;
  onClick?: (id: string) => void;
}

const TableRow = ({
  fields,
  keyId,
  record,
  hasCheckbox,
  isSelected,
  loading,
  position,
  onClick,
  onSelect,
}: TableRowProps) => {
  const handleOnSelectRow = (checked: boolean) => {
    if (onSelect && record?.[keyId] && !loading) {
      onSelect(record[keyId], checked);
    }
  };

  const handleClickRow = () => {
    onClick?.(record?.[keyId]);
  };

  return (
    <div
      onClick={handleClickRow}
      className={cn(
        styles.container,
        "hover:bg-primary-50 relative w-full bg:white border-b pb-4 border-line-500",
        onClick && "cursor-pointer"
      )}
    >
      <div className="px-[1.58rem]">
        <div className="flex justify-between text-night items-center w-full gap-2 pt-4">
          {hasCheckbox && (
            <div
              className={cn("mt-1", styles.table_column, styles.table_checkbox)}
              style={{ width: "25px" }}
            >
              <CheckboxV2 checked={isSelected} onCheck={handleOnSelectRow} />
            </div>
          )}

          {fields.map((field) => {
            const Component = field.component;
            return (
              <div
                key={field.key}
                className={cn(field.width ? `w-[${field.width}]` : undefined)}
                style={{
                  width: field.width ? field.width : undefined,
                }}
              >
                {field.component ? (
                  <Component
                    field={field}
                    record={record}
                    position={position}
                  />
                ) : (
                  <></>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TableRow;
